/**
 * ReadOnlyModeProvider
 *
 * Provides a context flag to disable mutation UI and actions throughout
 * the component tree when viewing shared analytics.
 *
 * Components can check `isReadOnly` to:
 * - Hide mutation buttons (Pause, End, Refresh, etc.)
 * - Disable form submissions
 * - Prevent Redux dispatches for mutations
 * - Show different button labels ("Close" vs "Save")
 */

import React, { ReactNode } from "react";

import { ReadOnlyModeContext } from "./ReadOnlyModeContextDef";

interface ReadOnlyModeProviderProps {
  children: ReactNode;
  isReadOnly?: boolean;
}

export const ReadOnlyModeProvider = ({
  children,
  isReadOnly = true,
}: ReadOnlyModeProviderProps) => {
  return (
    <ReadOnlyModeContext.Provider value={{ isReadOnly }}>
      {children}
    </ReadOnlyModeContext.Provider>
  );
};
